import api from '../../services/api';

const baseUrl = 'requests/production';

const findByRequestId = async (requestId) =>
    api.get({ service: `${baseUrl}/${requestId}/review` });

const findAllReviewsByRequestId = async (requestId) =>
    api.get({ service: `${baseUrl}/${requestId}/reviews` });

const saveReview = async (requestId, data) =>
    api.post({ service: `${baseUrl}/${requestId}/review-checklist`, data });

export default {
    findByRequestId,
    findAllReviewsByRequestId,
    saveReview
}
